import React from 'react';
import { LoadingComponent } from 'shared/components';
import { _HomeService } from 'modules/home/HomeService';
import { Link } from 'react-router-dom';

export default class Footer extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            data: null,
        };
        this.subscriptions = {};

    }
    componentDidMount() {
        this.setState({ loading: true });
        _HomeService.getFooterContentHome().subscribe(res => {
            this.setState({ data: res.data, loading: false });
        });

    }
    render() {
        let { data } = this.state;
        return (
            <div id="footer">
                <LoadingComponent loading={this.state.loading}></LoadingComponent>
                <div className="container">
                    <div className="row pb-2">
                        <div className="col-md-8 pt-3 footer-padding">
                            <div className="footer-1">
                                <div className="contact-info" dangerouslySetInnerHTML={{ __html: data?.hotline }}>

                                </div>
                            </div>
                            <div className="mt-3">
                                <a href="http://online.gov.vn/nen-tang/66105c00-d5d2-487a-aaa8-d9f5ec63668c" target="_blank" rel="noopener noreferrer">
                                    <img src="/logo-da-thong-bao-bo-cong-thuong.webp" alt="Đã thông báo Bộ Công Thương" style={{ maxWidth: '150px' }} />
                                </a>
                                <div className="mt-2 text-white" style={{ fontSize: '14px' }}>
                                    Giấy phép cho phép Trung tâm ngoại ngữ hoạt động giáo dục số 2023/QĐ-SGDĐT do Sở Giáo dục và đào tạo UBND Thành phố Hà Nội cấp ngày 15/08/2024
                                </div>
                            </div>
                        </div>
                        <div className="col-md-4 pt-3 footer-padding">
                            <div className="footer-policy">
                                <p className="text-white" style={{ fontWeight: 'bold', marginBottom: '10px' }}>CHÍNH SÁCH VÀ QUY ĐỊNH</p>
                                <ul className="list-unstyled" style={{ lineHeight: '30px' }}>
                                    <li><Link to="/chinh-sach-bao-mat-thong-tin" className="text-white" style={{ textDecoration: 'none' }}>Chính sách bảo mật thông tin</Link></li>
                                    <li><Link to="/phuong-thuc-thanh-toan" className="text-white" style={{ textDecoration: 'none' }}>Phương thức thanh toán</Link></li>
                                    <li><Link to="/chinh-sach-giao-nhan-kiem-tra-dich-vu" className="text-white" style={{ textDecoration: 'none' }}>Chính sách giao nhận - kiểm tra dịch vụ</Link></li>
                                    <li><Link to="/chinh-sach-huy-thi-va-hoan-phi" className="text-white" style={{ textDecoration: 'none' }}>Chính sách hủy thi và hoàn phí</Link></li>
                                    <li><Link to="/quyen-va-nghia-vu" className="text-white" style={{ textDecoration: 'none' }}>Quyền và nghĩa vụ của công ty và khách hàng</Link></li>
                                    <li><Link to="/phuong-thuc-giai-quyet-khieu-nai" className="text-white" style={{ textDecoration: 'none' }}>Phương thức tiếp nhận và giải quyết khiếu nại</Link></li>
                                    <li><Link to="/chinh-sach-ve-gia" className="text-white" style={{ textDecoration: 'none' }}>Chính sách về giá</Link></li>
                                    <li><Link to="/cac-dieu-kien-han-che-trong-cung-cap-dich-vu" className="text-white" style={{ textDecoration: 'none' }}>Các điều kiện hoặc hạn chế trong việc cung cấp dịch vụ</Link></li>
                                </ul>
                            </div>
                        </div>
                        <div className="col-md-12 pt-3 footer-padding">
                            <p className="text-white text-right">Phát triển bởi <a className="text-white" target="_blank" href="http://hcmedia.com.vn/">HCmedia</a></p>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
